/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerWorkedLogData model module.
 * @module model/ManagerWorkedLogData
 * @version 1.0
 */
class ManagerWorkedLogData {
    /**
     * Constructs a new <code>ManagerWorkedLogData</code>.
     * @alias module:model/ManagerWorkedLogData
     */
    constructor() { 
        
        ManagerWorkedLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerWorkedLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerWorkedLogData} obj Optional instance to populate.
     * @return {module:model/ManagerWorkedLogData} The populated <code>ManagerWorkedLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerWorkedLogData();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('createdIp')) {
                obj['createdIp'] = ApiClient.convertToType(data['createdIp'], 'Blob');
            }
            if (data.hasOwnProperty('workedLogNo')) {
                obj['workedLogNo'] = ApiClient.convertToType(data['workedLogNo'], 'Number');
            }
            if (data.hasOwnProperty('note')) {
                obj['note'] = ApiClient.convertToType(data['note'], 'String');
            }
            if (data.hasOwnProperty('loginAt')) {
                obj['loginAt'] = ApiClient.convertToType(data['loginAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerWorkedLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerWorkedLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['note'] && !(typeof data['note'] === 'string' || data['note'] instanceof String)) {
            throw new Error("Expected the field `note` to be a primitive type in the JSON string but got " + data['note']);
        }

        return true;
    }


}



/**
 * @member {String} email
 */
ManagerWorkedLogData.prototype['email'] = undefined;

/**
 * @member {String} name
 */
ManagerWorkedLogData.prototype['name'] = undefined;

/**
 * @member {Date} createdAt
 */
ManagerWorkedLogData.prototype['createdAt'] = undefined;

/**
 * @member {Blob} createdIp
 */
ManagerWorkedLogData.prototype['createdIp'] = undefined;

/**
 * @member {Number} workedLogNo
 */
ManagerWorkedLogData.prototype['workedLogNo'] = undefined;

/**
 * @member {String} note
 */
ManagerWorkedLogData.prototype['note'] = undefined;

/**
 * @member {Date} loginAt
 */
ManagerWorkedLogData.prototype['loginAt'] = undefined;






export default ManagerWorkedLogData;

